'use client';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import { ReactElement, ReactNode, useRef, useState } from 'react';
import Slider, { Settings } from 'react-slick';

import ImageCarouselDots from './ImageCarouselDots';
import ImageCarouselPaging from './ImageCarouselPaging';

import './style.css';

export interface ImageCarouselProps {
  children: ReactNode | ReactElement[];
}

export default function ImageCarousel({ children }: ImageCarouselProps) {
  const [activeSlide, setActiveSlide] = useState<number>(0);

  const sliderRef = useRef<Slider | null>(null);

  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
    initialSlide: 0,
    pauseOnHover: false,
    appendDots: dots => (
      <ImageCarouselDots
        dots={dots}
        goBack={() => {
          sliderRef.current?.slickGoTo(activeSlide + 1);
        }}
        goNext={() => {
          sliderRef.current?.slickGoTo(activeSlide - 1);
        }}
      />
    ),
    customPaging: i => (
      <ImageCarouselPaging
        key={i}
        index={i}
        activeSlide={activeSlide}
        onSlideChange={async currentSlide => {
          sliderRef.current?.slickGoTo(currentSlide);
          setActiveSlide(currentSlide);
        }}
      />
    ),
    beforeChange: (currentSlide: number, nextSlide: number) => {
      setActiveSlide(nextSlide);
    },
  };

  return (
    <div className="w-[100%]">
      <Slider {...settings} ref={sliderRef} className="banner-slider relative">
        {children}
      </Slider>
    </div>
  );
}
